import { render, staticRenderFns } from "./OrganismPolicyManagement.vue?vue&type=template&id=5c8c772c&scoped=true&"
import script from "./OrganismPolicyManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismPolicyManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismPolicyManagement.vue?vue&type=style&index=0&id=5c8c772c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c772c",
  null
  
)

export default component.exports